<template>
<section class="fix">
  <ul>
    <li class="qr-wrapper">
      <span class="iconfont icon-erweima"></span>
      <div class="arrow_box">
        <!-- <img src="http://g/qcode/index?url=http%3A%2F%2Fqconbj2017.geekbang.org"> -->
        <qrcode :val="url" :size="120"></qrcode>
        <small>扫一扫在手机端查看</small>
      </div>
    </li>
    <!-- <li class="wechat">
      <img class="wechat" src="./assets/icon-wechat.svg">
      <div class="dot" :class="{active: showWechatDot}"></div>
      <div class="follow is-2">
        <img src="./assets/qrcode-customer.jpg">
        <div class="right">在报名过程中如有任何问题，欢迎微信扫描左方二维码联系我们的票务经理</div>
      </div>
    </li> -->
    <!-- <li>
      <img src="../../assets/fix/qrcode.jpg">
      <div class="follow">
        <div class="border">
          <img src="../../assets/qrcode-as.png" alt="ArchSummit">
        </div>
        <img src="../../assets/qrcode-infoq.png" alt="infoQ">
      </div>
    </li> -->
    <!-- <li id="anchor_point_wrapper" style="display: block">
      <a href="#partner" class="anchor_point_image">
        <img class="partner_image" src="../../assets/fix/partner.png">
      </a>
      <div class="anchor_point_partner">
        <small>点击获得<br>QCon北京2017<br>赞助方案</small>
      </div>
    </li> -->
    <li @click="backToTop" class="back-top-icon" :class="!scrollTop?'scrollTop0':'scrollTop'">
      <span class="iconfont icon-huidaodingbu"></span>
    </li>
  </ul>
</section>
</template>

<script>
import Qrcode from '../com-qrcode'
import { scrollTop } from '../../util/methods'

export default {
  components: {
    Qrcode
  },
  props: [],
  data () {
    return {
      showWechatDot: false,
      scrollTop: 0
    }
  },
  computed: {
    url () {
      return window.location.href
    }
  },
  mounted () {
    window.addEventListener('scroll', this.windowScroll)
  },
  beforeDestroy () {
  },
  methods: {
    backToTop () {
      scrollTop(window, document.documentElement.scrollTop || document.body.scrollTop, 0, 500)
    },
    windowScroll () {
      // 滚动条距离页面顶部的距离
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    }
  },
  filters: {
  }
}
</script>

<style lang="sass" scoped>
@import '../../style/bulma/app.sass'

.fix
  position: fixed
  z-index: 1000
  right: 20px
  bottom: 100px
  +mobile
    display: none
  ul
    width: 52px
    // border-bottom: 1px solid #d6dce3
    li
      position: relative
      height: 50px
      width: 50px
      cursor: pointer
      background: #F8F8F8
      display: flex
      align-items: center
      justify-content: center
      transition: all .3s linear
      .iconfont
        transition: all .3s linear
        color: #666666
        font-size: 20px
    li.qr-wrapper
      border-radius: 7px 7px 0 0
    li.back-top-icon
      border-radius: 0 0 7px 7px
    li
      &:first-of-type
        margin-bottom: 2px
        &:hover
          background-color: #EFEFEF
          .iconfont
            color: $primary3
          .arrow_box
            display: flex
            flex-direction: column
            align-items: center
      &.back-top-icon
        &.scrollTop0
          .iconfont
            color: rgba(102, 102, 102, .2)
        &.scrollTop:hover
          background-color: #F8F8F8
          .iconfont
            color: $primary3
      .arrow_box
        display: none
        position: absolute
        width: 165px
        right: 70px
        top: -136px
        background-color: #fff
        padding: 17px
        border-radius: 7px
        box-shadow: 0px 0px 19px 0px rgba(74,74,74,0.08)
        // border: 1px solid #d6dce3
      .anchor_point_partner
        display: none
        position: absolute
        width: 153px
        right: 70px
        top: 0
        background-color: #fff
        padding: 14px 26px 10px 23px
        border: 1px solid #d6dce3
        color: #8e9ca9
        font-size: 15px
        text-align: center
        line-height: 22.5px
      .follow
        display: none
        position: absolute
        width: 286px
        right: 70px
        top: -4px
        padding: 0 15px
        background-color: #fff
        border: 1px solid #d6dce3
        &:after, &:before
          left: 100%
          top: 22%
          border: solid transparent
          content: " "
          height: 0
          width: 0
          position: absolute
          pointer-events: none
        &:after
          border-color: rgba(255, 255, 255, 0)
          border-left-color: #fff
          border-width: 8px
          margin-top: -8px
        &:before
          border-color: rgba(214, 220, 227, 0)
          border-left-color: #d6dce3
          border-width: 9px
          margin-top: -9px
        .border
          display: inline-block
          margin-right: 15px
          padding-right: 15px
          border-right: 1px solid #d6dce3
        img
          padding: 11px 0
          width: 106px
          display: inline-block
        .anchor_point_partner
          display: none
          position: absolute
          width: 153px
          right: 70px
          top: 0
          background-color: #fff
          padding: 14px 26px 10px 23px
          border: 1px solid #d6dce3
          color: #8e9ca9
          font-size: 15px
          text-align: center
          line-height: 22.5px
          &:after, &:before
            left: 100%
            top: 22%
            border: solid transparent
            content: " "
            height: 0
            width: 0
            position: absolute
            pointer-events: none
          &:after
            border-color: rgba(255, 255, 255, 0)
            border-left-color: #fff
            border-width: 8px
            margin-top: -8px
          &:before
            border-color: rgba(214, 220, 227, 0)
            border-left-color: #d6dce3
            border-width: 9px
            margin-top: -9px
        .anchor_point_image img
          width: 34px
</style>
